export {
  getSimplifiedComponentPrevalenceLookup,
  getTraditionalComponentPrevalenceLookup,
  type GraphemeComponentPrevalenceLookup,
} from "#component-prevalence-lookup";
export { type DecompositionMap, EMPTY_DECOMPOSITION_MAP } from "#decomposition-map";
export { collectTransitiveComponents } from "#transitive-components";
export {
  decompositionMapQueryFn,
  useDecompositionMapQueryOptions,
  useGetDecompositionMapQueryKey,
} from "#use-decomposition-map-query";
